import {IDisplayScrollManager} from "./Modules/types";

export class SimpleScroller implements IDisplayScrollManager {
    private container: HTMLDivElement;
    private _initialOffset: number;
    private _currentOffset: number;
    private _containerTop: number = 0;

    constructor(wordWrapperId: string) {
        this.container = document.getElementById(wordWrapperId) as HTMLDivElement;
    }

    reset() {
        this._containerTop = 0;
        this._initialOffset = 0;
        this._currentOffset = 0;
        this.applyScroll();
    }

    scrollToCurrentWord(currentWordIndex: number): void {
        const currentWord = this.container.children[currentWordIndex];
        const currentWordTop = currentWord?.getBoundingClientRect().top;
        if (currentWordIndex === 0) {
            this._initialOffset = currentWordTop;
        }
        this._currentOffset = currentWordTop;
        if (this._initialOffset !== this._currentOffset && currentWordTop !== this._initialOffset) {
            this._containerTop += this._initialOffset - this._currentOffset;
        }
        this.applyScroll();
    }

    private applyScroll() {
        this.container.style.top = `${this._containerTop}px`;
    }

    getDebugInfo(): string {
        return `
            Initial Offset: ${this._initialOffset}
            Current Offset: ${this._currentOffset}
            Container Top: ${this._containerTop}
            
            `
    }

}